import axios, { AxiosResponse } from 'axios';
import { IActionContext } from '@msdyn365-commerce/core';

export interface IReferenceData {}
export interface IChanges {
    ProductId: number;
    ItemId?: string;
    ChangeIn?: string;
    Result?: string;
    ValueType?: string;
    OriginalValue?: number;
    UpdatedValue?: number;
    References?: IReferenceData;
    VSIUniqueId?: string;
}

/**
 * VSICompareCartDataResponse entity interface.
 */
export interface IVSICompareCartDataResponse {
    CartId?: string;
    Changes?: IChanges[];
}

export const fetchPersistCartChanges = async (cartId: string, ctx: IActionContext): Promise<IVSICompareCartDataResponse> => {
    const data = JSON.stringify({
        _cartRequest: {
            CartID: cartId
        }
    });

    const headers = {
        accept: 'application/json',
        'accept-language': 'en-GB',
        'content-type': 'application/json',
        contenttype: 'application/json',
        oun: ctx.requestContext.apiSettings.oun
    };

    const isAuthenticated = ctx.requestContext.user.isAuthenticated;
    if (isAuthenticated) {
        const userToken = ctx.requestContext.user.token;
        headers['Authorization'] = `id_token ${userToken}`;
    }

    const response: AxiosResponse<IVSICompareCartDataResponse> = await axios({
        method: 'POST',
        url: `${ctx.requestContext.apiSettings.baseUrl}/Commerce/VSICompareCart`,
        data: data,
        headers: headers
    });
    return response.data;
};
